"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _clsx = _interopRequireDefault(require("clsx"));
var _cart = require("@bento-core/cart");
var _ContextProvider = require("../../../table/ContextProvider");
var _Actions = require("../../../table/state/Actions");
var _AddSelectedFilesView = _interopRequireDefault(require("./AddSelectedFilesView"));
var _WrapperService = require("../../WrapperService");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var AddSelectedFilesController = function AddSelectedFilesController(props) {
  var clsName = props.clsName,
    section = props.section,
    addFileQuery = props.addFileQuery,
    responseKeys = props.responseKeys,
    dataKey = props.dataKey,
    addFiles = props.addFiles,
    setOpenSnackbar = props.setOpenSnackbar,
    setAlterDisplay = props.setAlterDisplay,
    client = props.client;
  var tableContext = (0, _react.useContext)(_ContextProvider.TableContext);
  var context = tableContext.context;
  var _context$selectedRows = context.selectedRows,
    selectedRows = _context$selectedRows === void 0 ? [] : _context$selectedRows,
    dispatch = context.dispatch;
  var variables = {};
  variables[dataKey] = selectedRows;
  // add selected files id
  var addSelectedFiles = function addSelectedFiles() {
    var fileIds = (0, _WrapperService.getFilesID)({
      client: client,
      variables: variables,
      fileIds: selectedRows,
      query: addFileQuery
    });
    fileIds().then(function (response) {
      var ids = response[responseKeys[0]] || [];
      if (ids.length >= 1000) {
        setAlterDisplay(true);
      } else {
        addFiles(ids);
        setOpenSnackbar(true);
        dispatch((0, _Actions.onRowSeclect)([]));
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AddSelectedFilesView.default, _extends({}, props, {
    eventHandler: addSelectedFiles,
    clsName: (0, _clsx.default)(clsName, "".concat(clsName, "_").concat(section)),
    disabled: selectedRows.length === 0
  })));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    addFiles: function addFiles(files) {
      dispatch((0, _cart.onAddCartFiles)(files));
    }
  };
};
var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(AddSelectedFilesController);
exports.default = _default;